const busTypes = {
  // Global - Popups
  OPEN_GLOBAL_POPUP: 'openGlobalPopup',
  CLOSE_GLOBAL_POPUP: 'closeGlobalPopup',
  SAVE_GLOBAL_POPUP: 'saveGlobalPopup',

  // Global Issue Manager
  OPEN_MANAGE_ISSUE: 'openManageIssue',
  CLOSE_MANAGE_ISSUE: 'closeManageIssue',
  SAVE_MANAGE_ISSUE: 'saveManageIssue',

  // Project
  GET_PROJECT_INFO: 'getProjectInformation',
};

export default busTypes;
